export const getGexRegimePresentation = (regime) => {
  const values = {
    POSITIVE: { label: 'Positivo', tone: 'text-[#4ADE80]', badge: 'border-[#4ADE80]/25 bg-[#4ADE80]/10 text-[#86EFAC]' },
    NEGATIVE: { label: 'Negativo', tone: 'text-[#F87171]', badge: 'border-[#F87171]/25 bg-[#F87171]/10 text-[#FCA5A5]' },
    NEUTRAL: { label: 'Neutro', tone: 'text-white/80', badge: 'border-white/15 bg-white/[0.06] text-white/75' },
    INDETERMINATE: { label: 'Indeterminado', tone: 'text-white/55', badge: 'border-white/10 bg-white/[0.04] text-white/55' },
  };
  return values[regime] || values.INDETERMINATE;
};

export const formatGexPrice = (value) => {
  if (value === null || value === undefined || !Number.isFinite(Number(value))) return '—';
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(Number(value));
};

export const getGexStatusLabel = (status) => ({
  fresh: 'Atualizado',
  stale: 'Último dado disponível',
  unavailable: 'Dados indisponíveis',
}[status] || 'Dados indisponíveis');